import React from "react";
// FacebookIcon/InstagramIcon are commented out in ./Atom/icons and unused here;
// importing them fails the production build with "Attempted import error".
import { LinkinkedIcons, WhatsappIcon } from "./Atom/icons";

export const SocialMedia = () => {
  return (
    <div className="h-24 w-12 bg-primary-wind fixed z-10 inset-0 top-[40%] shadow-xl shadow-blue-300 rounded-r-md ">
      <div className="container mx-auto px-2 py-3">
        <div className="space-y-5">
          <div className=" transform transition duration-1000 hover:scale-150">
            <a href="https://www.linkedin.com/company/bin-haider-advocates-&-legal-consultants/">
              <LinkinkedIcons />
            </a>
          </div>

          <div className=" transform transition duration-1000 hover:scale-150">
            <a href="#">
              <WhatsappIcon />
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};
